import React from "react";
import {useEffect,useState} from "react";
import { Link } from "react-router-dom";
import "./home.css"
import Model from "../Model/Model"
import home_anime from "../../assets/home_anime.gif"



export default function Home(props) {

    const [displayModel, setDisplayModel] = useState(false);

    const closeModel = ()=>{
        setDisplayModel(false);
    }
   let effect= useEffect(() => {
        console.log("Home Component is loaded");
        setTimeout(()=>(setDisplayModel(true)),5000);
    }, []);
    return <div className="head-contanier">
            {displayModel && <Model onclose={closeModel}/>}
               <div className="header-text">
               <h1>Welcome to My Portfolio</h1> 
               <p>This is Prashank Jauhari, A fullstack developer.</p>
               </div>
               <div className="head-btns">
                   <Link to="/about" className="btn btn-white">
                       <p className="btn-text">Know more about me</p>
                   </Link>
                   {/* <Link to="/about" className="btn btn-white">
                       <p className="btn-text">Contact me</p>
                   </Link> */}
                </div>

                <div className="splash-image">
                        <img src={home_anime}
                        alt="animation"
                        className="home-anime"/>
                </div>
            </div>
}